import PropTypes from "prop-types";

// Custom funnel built with stacked horizontal bars for a funnel visual
// Recharts doesn't have native funnel, so we use a custom SVG approach
export function FunnelChart({ data, colors, onBarClick }) {
  const maxVal = Math.max(...data.map(d => d.value), 1);
  const barHeight = Math.min(34, Math.floor(180 / data.length) - 6);

  return (
    <div
      style={{
        width: "100%",
        height: 280,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 6,
        padding: "8px 0",
      }}
    >
      {data.map((item, i) => {
        const widthPct = Math.max(20, (item.value / maxVal) * 100);
        const color = colors?.[i] || "#60a5fa";
        return (
          <div
            key={item.name}
            role={onBarClick ? "button" : undefined}
            tabIndex={onBarClick ? 0 : undefined}
            onClick={() => onBarClick?.(item)}
            onKeyDown={e => {
              if (onBarClick && (e.key === "Enter" || e.key === " ")) {
                e.preventDefault();
                onBarClick(item);
              }
            }}
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              gap: 10,
              cursor: onBarClick ? "pointer" : "default",
              animation: `funnelSlideIn 0.5s ease-out ${i * 0.1}s both`,
            }}
          >
            <span
              style={{
                width: 110,
                textAlign: "right",
                fontSize: "0.75rem",
                fontWeight: 500,
                color: "#9ca3af",
                flexShrink: 0,
              }}
            >
              {item.name}
            </span>
            <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
              <div
                style={{
                  width: `${widthPct}%`,
                  height: barHeight,
                  background: `linear-gradient(90deg, ${color}, ${color}cc)`,
                  borderRadius: 6,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "width 0.8s ease-out",
                  boxShadow: `0 2px 8px ${color}33`,
                }}
              >
                <span style={{ fontSize: "0.72rem", fontWeight: 700, color: "#fff" }}>{item.value}</span>
              </div>
            </div>
          </div>
        );
      })}
      <style>{`
        @keyframes funnelSlideIn {
          from { opacity: 0; transform: translateX(-20px); }
          to { opacity: 1; transform: translateX(0); }
        }
      `}</style>
    </div>
  );
}

FunnelChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, value: PropTypes.number })).isRequired,
  colors: PropTypes.array,
  onBarClick: PropTypes.func,
};

export default FunnelChart;
